<div class="c-tabs h-100">
  <div class="c-tabs__header">
    @if (!isSelf) {
      <button
        type="button"
        class="c-tabs__label"
        [class.c-tabs__label--active]="activeTab() === 0"
        (click)="setTab(0)">
        {{ 'home.trophies.header' | translate }}
      </button>
    }
    <button
      type="button"
      class="c-tabs__label"
      [class.c-tabs__label--active]="activeTab() === (isSelf ? 0 : 1)"
      (click)="setTab(isSelf ? 0 : 1)">
      <span class="c-tabs__label-text">
        {{ 'home.friends.header' | translate }}
        @if (hasPendingFriends()) {
          <span class="c-tabs__badge">{{ pendingFriends() }}</span>
        }
      </span>
    </button>
  </div>
  <div class="c-tabs__body">
    @if (!isSelf && activeTab() === 0) {
      <slotcom-recurring-hall [user]="user"> </slotcom-recurring-hall>
    }
    @if (activeTab() === (isSelf ? 0 : 1)) {
      <slotcom-friends
        [user]="user"
        [isSelf]="isSelf"
        (pendingFriends)="onPendingFriends($event)">
      </slotcom-friends>
    }
  </div>
</div>
